<span
  fxLayout="row"
  class="tank-search"
  fxLayoutAlign="start center"
>
  <mat-form-field [appearance]="'legacy'" class="tank-search-select">
    <mat-select
      [(ngModel)]="selectedSearchType"
      siteUsageTracker
      [logCategory]="'TankSearch'"
      [logName]="'TankSearcTypeSelector'"
      class="tank-search-dropdown"
    >
      <mat-option value="0">{{ 'Header.SerialNumber' | translate }}</mat-option>
      <mat-option value="1">{{ 'Header.MinNumber' | translate }}</mat-option>
      <mat-option value="2">{{ 'Header.TankName' | translate }}</mat-option>
      <mat-option value="3">{{ 'Header.Location' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
  <input
     [(ngModel)]="searchValue"
    matInput
    type="text"
    #searchBox
    (keyup.enter)="onSearch()"
    siteUsageTracker
    [logCategory]="'TankSearch'"
    [logKeyEnter]="true"
    [logName]="'tankSearchInputBox'"
    [placeholder]="'Header.TankSearchText' | translate"
    class="tank-search-text"
  />
  <span class="tank-search-magnifier">
    <mat-spinner
      *ngIf="searching"
      [diameter]="22"
      class="p2 mr-4"
    ></mat-spinner>
    <button
      *ngIf="!searching"
      mat-button
      siteUsageTracker
      [logCategory]="'TankSearch'"
      [logName]="'TankSearchButton'"
      (click)="onSearch()"
      [disabled]="!searchValue || searchValue.length < 3"
    >
      <mat-icon>search</mat-icon>
    </button>
  </span>
</span>
